<ng-container *ngIf="links$ | async as links">
  <ng-container *ngIf="links.upselling?.products?.length || links.upselling?.categories?.length">
    <ish-product-links-carousel
      [links]="links.upselling"
      [productLinkTitle]="'product.product_links.upselling.title' | translate"
      [displayOnlyAvailableProducts]="true"
    ></ish-product-links-carousel>
  </ng-container>
  <ng-container *ngIf="links.spareparts?.products?.length || links.spareparts?.categories?.length">
    <ish-product-links-carousel
      [links]="links.spareparts"
      [productLinkTitle]="'product.product_links.spareparts.title' | translate"
    ></ish-product-links-carousel>
  </ng-container>
  <ng-container *ngIf="links.crossselling?.products?.length || links.crossselling?.categories?.length">
    <ish-product-links-carousel
      [links]="links.crossselling"
      [productLinkTitle]="'product.product_links.crossselling.title' | translate"
      [displayOnlyAvailableProducts]="true"
    ></ish-product-links-carousel>
  </ng-container>
  <ng-container *ngIf="links.accessory?.products?.length || links.accessory?.categories?.length">
    <ish-product-links-carousel
      [links]="links.accessory"
      [productLinkTitle]="'product.product_links.accessory.title' | translate"
    ></ish-product-links-carousel>
  </ng-container>
  <ng-container *ngIf="links.differentorderunit?.products?.length || links.differentorderunit?.categories?.length">
    <ish-product-links-carousel
      [links]="links.differentorderunit"
      [productLinkTitle]="'product.product_links.differentorderunit.title' | translate"
    ></ish-product-links-carousel>
  </ng-container>
  <ng-container *ngIf="links.followup?.products?.length || links.followup?.categories?.length">
    <ish-product-links-carousel
      [links]="links.followup"
      [productLinkTitle]="'product.product_links.followup.title' | translate"
    ></ish-product-links-carousel>
  </ng-container>
  <ng-container *ngIf="links.other?.products?.length || links.other?.categories?.length">
    <ish-product-links-carousel
      [links]="links.other"
      [productLinkTitle]="'product.product_links.other.title' | translate"
    ></ish-product-links-carousel>
  </ng-container>
  <ng-container *ngIf="links.replacement?.products?.length || links.replacement?.categories?.length">
    <ish-product-links-carousel
      [links]="links.replacement"
      [productLinkTitle]="'product.product_links.replacement.title' | translate"
    ></ish-product-links-carousel>
  </ng-container>
</ng-container>
